const updatePlayTimer = (state = {}, action) => {
    const { datasource } = action;

    if (datasource === 'gumbo') {
        const { liveData } = action.data;
        const { currentPlay, allPlays } = liveData?.plays;

        return {
            ...state,
            allPlays,
            currentPlay
        };
    }

    return state;
};

export default updatePlayTimer;
